import { render, staticRenderFns } from "./ImagesGalleryFullscreenModal.vue?vue&type=template&id=63d6682a&"
import script from "./ImagesGalleryFullscreenModal.vue?vue&type=script&lang=ts&"
export * from "./ImagesGalleryFullscreenModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports